import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Card, Table } from '../../onestep-library/BaseUI'
import moment from 'moment'

import PendingInvoiceListing from './components/PendingInvoiceListing'
import MakePaymentForm from './components/MakePaymentForm'
import NewInvoiceForm from './components/NewInvoiceForm'
import EditPendingInvoice from './components/EditPendingInvoice'
import { Elements } from 'react-stripe-elements'

import { fetchPendingInvoices } from './actions'

function PendingInvoices(props){
  const dispatch = useDispatch()
  const { pendingInvoices, ui } = useSelector(state=>state.pendingInvoices)
  const { loading } = ui
  const newInvoiceForm = useSelector(state=>state.newInvoiceForm)
  const [ currentInvoiceOnMakePayment , setCurrentInvoiceOnMakePayment ] = useState({})

  // fetch pending invoices
  useEffect(()=>{
    dispatch(fetchPendingInvoices())
  },[])

  function setNewInvoiceVisible(){
    dispatch({type: 'UPDATE_NEW_INVOICE_UI', payload: {show: true}})
  }

  return(
    <div>
      <Elements>
        <MakePaymentForm/>
      </Elements>
      <EditPendingInvoice/>
      <Card
        visible={pendingInvoices.length > 0}
        title="Pending"
        isLoading={loading}
        className="mt-4">
        <Table
          columnNames={[`Due On`, 'Created On', "Memo", "Amount Due", "", ""]}
          rows={pendingInvoices}
          Row={PendingInvoiceListing}
          zeroCaseMessage="No Invoices"/>
      </Card>
    </div>
  )
}

export default PendingInvoices